import 'css/mobile/post-display.scss';

import 'js/mobile/common/common.jquery';

import 'js/plugin/jquery-facebook-sdk/facebook-sdk.jquery.js';
import 'js/plugin/share-bar.jquery.js';
import 'js/plugin/jquery-featured-post/featured-post.mobile.jquery.js';

var useAMP = true;

var $sbFacebookBtn = $('.share-bar--fixed amp-social-share[type="facebook"]');
var $sbfShareCount = $('.share-bar--fixed__share-count');

/**
 * Load and initializes the Facebook SDK.
 */
$(document).fbSDK()
  .on('fbSDK:graph:data:load', function(e, data) {
    if (data && data.engagement && data.engagement.share_count > 499) {
      if (useAMP) {
        $sbFacebookBtn.append('<span class="share-bar--fixed__badge share-bar--fixed__share-count">' + data.engagement.share_count + '</span>');
      } else {
        $sbfShareCount.text(data.engagement.share_count);
      }
      return;
    }

    $sbfShareCount.remove();
  });

/**
 * Load Open Graph data for fbComments and shareBar
 */
$.fbSDK.fetchGraphData();

window.addEventListener("DOMContentLoaded",function(){
	document.querySelectorAll('.featured-video iframe').forEach((elem) => {
		elem.style.margin = 0;

		var ratio = elem.getAttribute("height") / elem.getAttribute("width");

		elem.removeAttribute('width');
		elem.removeAttribute('height');

		var newWidth = document.querySelector('main > .post__description').offsetWidth;

		var newHeight = newWidth * ratio;

		elem.setAttribute("width",newWidth);
		elem.setAttribute("height",newHeight);
	});
});

$(document).ready(function () {
  /**
  * Resize embeded video to fit containr
  */

  /**
  * Style Instagram embeds
  */
  $('amp-instagram')
  .closest('.featured-video')
  .css({
    border: '1px solid #ddd',
    borderRadius: '3px'
  });

  /**
   * Init the share bar
   */
  $('.post__share-bar').shareBar({
    template: require('!handlebars-loader!../../views/mobile/post/share_bar_info_view.html'),
    disablePopups: true
  });

  /**
   * Load fetured post
   */
  $('#featured-now').featuredPost();

  //$.getScript('https://widgets.outbrain.com/outbrain.js');
});
